


import React, { useState } from "react";
import { Helmet } from 'react-helmet';
import Footer from "../../../components/en/FooterEn";
import { Link } from "react-router-dom";

function StudyInRussia() {

   // Estado para controlar el acordeón
   const [activeIndex, setActiveIndex] = useState(null);

   const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
   };


   return (
      <main>
         {/* ========================== SEO ========================== */}
         <Helmet>
            <title>Why Study in Russia? 10 Key Reasons and Complete Guide 2025 | PLAN RUSIA </title>
            <meta name="description" content="Is it worth studying in Russia? Discover 10 academic, economic and cultural advantages backed by official data. Updated guide with requirements for 2025" />
            <meta name="keywords" content="study in Russia, Russian universities, scholarships in Russia, study medicine in Russia, cost of living Russia" />
            <meta property="og:title" content="Why Study in Russia? Key Advantages for International Students" />
            <meta property="og:description" content="Everything you need to know to study in Russia: from admission to student life. Discover unique opportunities!" />
            <meta property="og:image" content="https://planrusia.com/assets/img/education/universidad-rusas-educacion.webp" />
            <link rel="canonical" href="https://planrusia.com/why-study-in-russia" />

            <meta property="og:url" content="https://planrusia.com/why-study-in-russia" />
            <meta property="og:type" content="article" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="10 Reasons to Study in Russia" />
            <meta name="twitter:image" content="https://planrusia.com/why-study-in-russia" />
         </Helmet>

         {/* ==================== Contenido Principal ==================== */}
         <section className="blog_area single-post-area section-padding">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8 posts-list">
                     <div className="single-post">
                        <div className="feature-img">
                           <img
                              className="img-fluid"
                              src="/assets/img/education/universidad-rusas-educacion.webp"
                              alt="International students on Russian university campus"
                              loading="lazy"
                           />
                        </div>

                        <div className="blog_details">
                           <h1 itemProp="headline">
                              Why Study in Russia? 10 Advantages You Should Know in 2025
                           </h1>

                           <div className="meta-info" itemScope itemType="http://schema.org/Article">
                              <span itemProp="datePublished"> June 1, 2025</span>
                              <span itemProp="author"> By - Russian Educational Council</span>
                           </div>

                           <ul className="blog-info-link mt-3 mb-4">
                              <li>
                                 <a href="#">
                                    <i className="fa fa-user" /> Education, Guides
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fa fa-comments" /> 12 Comments
                                 </a>
                              </li>
                           </ul>

                           <article itemProp="articleBody">


                              <p className="excert">
                                 With over 300,000 international students (according to <a href="https://uis.unesco.org/" target="_blank" rel="noopener noreferrer">UNESCO</a>), Russia positions itself as an educational powerhouse. But what makes it so attractive? We analyze academic, economic, and cultural factors.
                              </p>


                              {/* ============ ÍTEM 1 ============ */}
                              <h2>1. World-Class Education. Academic Excellence at Affordable Cost</h2>

                              <p>
                                 <strong>QS Ranking 2024</strong> includes 17 Russian universities among the top 500 worldwide. Notable ones:
                              </p>
                              <ul>
                                 <li>• Lomonosov Moscow State University - #74 worldwide in Physics</li>
                                 <li>• MIPT - Top 50 in Nuclear Engineering</li>
                                 <li>• MGIMO - #1 in International Relations in Eastern Europe</li>
                              </ul>
                              <p>
                                 Tuition from $2,500 annually vs $50,000 in Ivy League (<a href="https://www.minobrnauki.gov.ru/" target="_blank" rel="noopener noreferrer">Russian Ministry of Education</a>).
                              </p>



                              <p>Russia ranks <strong>6th globally</strong> in scientific production (Scimago 2023). Highlights:</p>
                              <div className="row mb-4">
                                 <div className="col-md-6">
                                    <div className="card uni-card h-100">
                                       <div className="card-body">
                                          <h5>Moscow State University (MSU)</h5>
                                          <ul>
                                             <li>#74 in QS World Rankings 2024</li>
                                             <li>11 Nobel Prizes</li>
                                             <li>Tuition: $3,000-$6,000/year</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="card uni-card h-100">
                                       <div className="card-body">
                                          <h5>ITMO University</h5>
                                          <ul>
                                             <li>#1 in Computer Science in Russia</li>
                                             <li>7-time ACM ICPC champion</li>
                                             <li>Full scholarships available</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 2 ============ */}
                              <h2>2. Government Scholarships (Full Quota) for Foreigners</h2>

                              <ol>
                                 <li>15,000 Annual Government Scholarships for top foreign students</li>
                                 <li>Full coverage: tuition + accommodation + medical insurance</li>
                                 <li>Online application November - December each year</li>
                              </ol>

                              <table className="table table-bordered">
                                 <thead className="thead-dark">
                                    <tr>
                                       <th>Scholarship Type</th>
                                       <th>Benefits</th>
                                       <th>Requirements</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr>
                                       <td>Government Scholarship</td>
                                       <td>100% tuition + accommodation</td>
                                       <td>Minimum average 80/100</td>
                                    </tr>
                                    <tr>
                                       <td>Open Doors</td>
                                       <td>Tuition + $500/month</td>
                                       <td>Talent and knowledge test</td>
                                    </tr>
                                 </tbody>
                              </table>
                              <p><small>Source: <a href="https://education-in-russia.com" target="_blank" rel="noopener">Education in Russia</a></small></p>




                              {/* ============ ÍTEM 3 ============ */}


                              <h2>3. Programs in English (Without Mastering Russian) </h2>

                              <p>
                                 58 universities offer 700+ programs in English in areas such as:
                              </p>
                              <ul>
                                 <li>• Medicine (MBBS recognized by WHO)</li>
                                 <li>• Aerospace Engineering</li>
                                 <li>• Artificial Intelligence</li>
                                 <li>• Nuclear Engineering </li>
                              </ul>

                              <div className="accordion mb-4" id="programsAccordion">
                                 {[
                                    {
                                       title: "Medicine (MBBS)",
                                       content: (
                                          <ul>
                                             <li><strong>Duration:</strong> 6 years</li>
                                             <li><strong>Recognition:</strong> WHO, ECFMG, GMC</li>
                                             <li><strong>Top Universities:</strong>
                                                <ul>
                                                   <li>Sechenov University (Moscow)</li>
                                                   <li>RUDN University</li>
                                                   <li>Kazan Federal University</li>
                                                </ul>
                                             </li>
                                             <li><strong>Requirements:</strong>
                                                <ul>
                                                   <li>Minimum grades: 80% in Biology/Chemistry</li>
                                                   <li>NEET exam for Indian students</li>
                                                </ul>
                                             </li>
                                          </ul>
                                       )
                                    },
                                    {
                                       title: "Aerospace Engineering",
                                       content: (
                                          <ul>
                                             <li><strong>Duration:</strong> 4 years (Bachelor)</li>
                                             <li><strong>Featured institutions:</strong>
                                                <ul>
                                                   <li>Moscow Aviation Institute (MAI)</li>
                                                   <li>Bauman Moscow State Technical University</li>
                                                </ul>
                                             </li>
                                             <li><strong>Focus areas:</strong>
                                                <ul>
                                                   <li>Rocket design</li>
                                                   <li>Space propulsion</li>
                                                   <li>Composite materials</li>
                                                </ul>
                                             </li>
                                             <li><strong>Internships:</strong> Roscosmos, United Aircraft</li>
                                             <li><strong>Average salary:</strong> $3,500/month</li>
                                          </ul>
                                       )
                                    },
                                    {
                                       title: "Artificial Intelligence",
                                       content: (
                                          <ul>
                                             <li><strong>Duration:</strong> 2 years (Master)</li>
                                             <li><strong>Featured institutions:</strong>
                                                <ul>

                                                   <li>Bauman Moscow State Technical University</li>
                                                </ul>
                                                <li><strong>Areas covered:</strong>
                                                   <ul>
                                                      <li>Machine Learning</li>
                                                      <li>Computer Vision</li>
                                                      <li>Natural Language Processing</li>
                                                   </ul>
                                                </li>
                                                <li><strong>Industry collaborations:</strong>
                                                   <ul>
                                                      <li>Yandex School of Data Analysis</li>
                                                      <li>Skolkovo Institute of Science and Technology</li>
                                                   </ul>
                                                </li>
                                             </li>
                                          </ul>
                                       )
                                    }

                                 ].map((item, index) => (
                                    <div className="accordion-item" key={index}>
                                       <button
                                          className={`accordion-button ${activeIndex === index ? 'active' : ''}`}
                                          onClick={() => toggleAccordion(index)}
                                       >
                                          {item.title}
                                          <span className="accordion-icon">
                                             {activeIndex === index ? '−' : '+'}
                                          </span>
                                       </button>
                                       <div
                                          className="accordion-body"
                                          style={{
                                             display: activeIndex === index ? 'block' : 'none'
                                          }}
                                       >
                                          {item.content}
                                       </div>
                                    </div>
                                 ))}
                              </div>

                              {/* ============ ÍTEM 4 ============ */}
                              <h2>4. Affordable Cost of Living</h2>

                              <p>
                                 Competitive cost of living. From $400/month in cities like Kazan vs $1,200+ in Western Europe (Numbeo data 2024).
                              </p>

                              <div className="row">
                                 <div className="col-md-6">
                                    <h5>Monthly Comparison (USD)</h5>
                                    <ul className="list-group">
                                       <li className="list-group-item d-flex justify-content-between align-items-center">
                                          Accommodation
                                          <span className="badge bg-primary rounded-pill">$150-$300</span>
                                       </li>
                                       <li className="list-group-item d-flex justify-content-between align-items-center">
                                          Food
                                          <span className="badge bg-primary rounded-pill">$200</span>
                                       </li>
                                    </ul>
                                 </div>
                                 <div className="col-md-6">
                                    <img src="/assets/img/education/universidad-rusas-educacion.webp" alt="Cost of living comparison Russia vs Europe" className="img-fluid" />
                                 </div>
                              </div>
                              <p><small>Source: <a href="https://www.numbeo.com" target="_blank" rel="noopener">Numbeo 2024</a></small></p>




                              {/* ============ ÍTEM 5 ============ */}
                              <h2>5. Work Visa for Graduates </h2>
                              <p>
                                 Graduates can apply for work residence through the "Highly Qualified Specialist" program.
                              </p>

                              <p>The <strong>"Highly Qualified Specialist"</strong> program allows:</p>
                              <ul>
                                 <li>Work without immigration quotas</li>
                                 <li>Guaranteed minimum salary: $1,700/month</li>
                                 <li>Permanent residence after 3 years</li>
                              </ul>

                              <ul>
                                 <li>• Student visa allows working 20h/week</li>
                                 <li>• Discounted travel on public transport</li>
                              </ul>



                              <div className="quote-wrapper">
                                 <div className="quotes">
                                    <h3>Key Facts</h3>
                                    <p>
                                       • Russia invests 4.3% of its GDP in higher education (vs 2.9% OECD average), according to <a href="https://data.oecd.org" target="_blank" rel="noopener noreferrer">OECD.Stat</a>.
                                    </p>
                                    <p>
                                       • Russia ranks 8th worldwide in scientific production according to Scimago 2023, surpassing Canada and Australia.
                                    </p>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 6 ============ */}
                              <h2>6. Gateway to Global Markets</h2>

                              <p>
                                 Degree recognition agreements with 64 countries from CIS, EU and Asia.
                              </p>
                              <p>
                                 Graduates of Russian universities have preferential access to:
                              </p>
                              <ul>
                                 <li>• "Highly Qualified Specialist" program to work in Russia</li>
                                 <li>• Diploma recognition agreements with 64 countries</li>
                              </ul>

                              <p>Employment advantages:</p>
                              <div className="row">
                                 <div className="col-md-6">
                                    <div className="card">
                                       <div className="card-body">
                                          <h5>Degree Recognition</h5>
                                          <p>Valid in 64 countries including:</p>
                                          <ul>
                                             <li>European Union</li>
                                             <li>China</li>
                                             <li>India</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-6">
                                    <div className="card">
                                       <div className="card-body">
                                          <h5>Global Companies</h5>
                                          <p>Agreements with:</p>
                                          <ul>
                                             <li>Gazprom</li>
                                             <li>Yandex</li>
                                             <li>Rosatom</li>
                                          </ul>
                                       </div>
                                    </div>
                                 </div>
                              </div>


                              {/* ============ ÍTEM 7 ============ */}
                              <h2>7. International Academic Climate. Active International Community</h2>                               

                              <p>In 2024, Russia hosts <strong>300,000+ foreign students</strong> from:</p>
                              <div className="country-chips">
                                 <span className="badge bg-light text-dark">China (23%)</span>
                                 <span className="badge bg-light text-dark">India (18%)</span>
                                 <span className="badge bg-light text-dark">Middle East (15%)</span>
                              </div>
                              <p>With organized communities by country in all major universities.</p>
                              <p>
                                 300,000+ foreign students from 170 countries creating a global network of contacts.
                              </p>


                              {/* ============ ÍTEM 8 ============ */}
                              <h2>8. Cutting-Edge Infrastructure</h2>
                              <p>
                                 Laboratories like those at the <Link to="/skolkovo">Skolkovo Innovation Center</Link> (the "Russian Silicon Valley") available to students.
                              </p>

                              <div className="row">
                                 <div className="col-md-6">
                                    <img src="assets/img/gallery/rusas-universidad-clases.png" alt="Skolkovo Innovation Center" className="img-fluid rounded" />
                                 </div>
                                 <div className="col-md-6">
                                    <p>Featured facilities:</p>
                                    <ul>
                                       <li>Nanotechnology laboratories</li>
                                       <li>Space simulators</li>
                                       <li>Libraries with 5M+ volumes</li>
                                    </ul>
                                 </div>
                              </div>



                              {/* ============ ÍTEM 9 ============ */}
                              <h2>9. Included Healthcare System</h2>
                              <p>All students receive:</p>
                              <ul>
                                 <li><strong>Medical insurance and free care:</strong> Full coverage</li>
                                 <li><strong>University clinics:</strong> 24/7 care</li>
                                 <li><strong>Vaccination:</strong> Voluntary and included</li>
                              </ul>


                              {/* ============ ÍTEM 10 ============ */}
                              <h2>10. Unique Cultural Experience. Living Culture and History</h2>
                              <p>
                                 From the <Link to="/metro-moscu">Moscow metro</Link> to the "White Nights" festival in St. Petersburg.
                              </p>
                              <p>
                                 Free access to museums and discounts at theaters including the Hermitage and the Bolshoi (according to <a href="https://www.culture.ru" target="_blank">official cultural portal</a>).
                              </p>

                              <div className="row">
                                 <div className="col-md-4">
                                    <div className="card">
                                       <img src="assets/img/gallery/rusas-universidad-clases.png" className="card-img-top" alt="Hermitage Museum" />
                                       <div className="card-body">
                                          <h5>Free Access</h5>
                                          <p>500+ museums for students</p>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-md-8">
                                    <p>Cultural benefits:</p>
                                    <ul>
                                       <li>50% discount at theaters like the Bolshoi</li>
                                       <li>Free festivals like "White Nights"</li>
                                    </ul>
                                 </div>
                              </div>


 


                              <br></br>


                              {/* ===== SECCIÓN FINAL ===== */}
                              <div className="alert alert-info mt-4">
                                 <h4>How to Apply?</h4>
                                 <ol>
                                    <li>Choose your program at <a href="https://studyinrussia.ru" target="_blank" rel="noopener">studyinrussia.ru</a></li>
                                    <li>Prepare documents (translated into Russian)</li>
                                    <li>Apply before 12/15/2025</li>
                                 </ol>
                              </div>

                              <br></br> <br></br>




                              <div className="faq-section">
                                 <h3>FAQ: Frequently Asked Questions</h3>
                                 <p><strong>How much does it cost to live?</strong><br />
                                    Between $300-$600/month including university residence (according to <a href="https://www.numbeo.com" target="_blank">Numbeo</a>).</p>

                                 <p><strong>Do I need to know Russian?</strong><br />
                                    Not for English programs, but all universities offer <Link to="/cursos-ruso">free courses</Link>.</p>
                              </div>

                              {/* ==================== Referencias Académicas ==================== */}
                              <div className="container mt-5 references">
                                 <h4>Sources Consulted</h4>
                                 <ul>
                                    <li>• UNESCO Institute for Statistics (2023). <em>Global Education Monitoring Report</em></li>
                                    <li>• QS World University Rankings 2024</li>
                                    <li>• Russian Ministry of Science and Higher Education</li>
                                    <li>• OECD Education at Glance 2023 Report</li>

                                 </ul>
                              </div>


                           </article>
                        </div>
                     </div>

                     {/* ============= Sección de navegación ============= */}
                     <div className="navigation-top">
                        <div className="d-sm-flex justify-content-between text-center">
                           <p className="like-info">
                              <span className="align-middle">
                                 <i className="fa fa-heart" />
                              </span>{" "}
                              Lily and 4 people like this
                           </p>
                           <div className="col-sm-4 text-center my-2 my-sm-0">
                              <p className="comment-count">
                                 <span className="align-middle">
                                    <i className="fa fa-comment" />
                                 </span> 06 Comments
                              </p>
                           </div>
                           <ul className="social-icons">
                              <li>
                                 <a href="#">
                                    <i className="fab fa-facebook-f" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-twitter" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-dribbble" />
                                 </a>
                              </li>
                              <li>
                                 <a href="#">
                                    <i className="fab fa-behance" />
                                 </a>
                              </li>
                           </ul>
                        </div>

                        <div className="navigation-area">
                           <div className="row">
                              <div className="col-lg-6 col-md-6 col-12 nav-left flex-row d-flex justify-content-start align-items-center">
                                 <div className="thumb">
                                    <a href="#">
                                       <img
                                          className="img-fluid"
                                          src="/assets/img/post/preview.png"
                                          alt="Previous post"
                                       />
                                    </a>
                                 </div>
                                 <div className="arrow">
                                    <a href="#">
                                       <span className="lnr text-white ti-arrow-left" />
                                    </a>
                                 </div>
                                 <div className="detials">
                                    <p>Prev Post</p>
                                    <a href="#">
                                       <h4>Salsa Parties in Winter</h4>
                                    </a>
                                 </div>
                              </div>
                              <div className="col-lg-6 col-md-6 col-12 nav-right flex-row d-flex justify-content-end align-items-center">
                                 <div className="detials">
                                    <p>Next Post</p>
                                    <a href="#">
                                       <h4>Best Dance Academies</h4>
                                    </a>
                                 </div>
                                 <div className="arrow">
                                    <a href="#">
                                       <span className="lnr text-white ti-arrow-right" />
                                    </a>
                                 </div>
                                 <div className="thumb">
                                    <a href="#">
                                       <img
                                          className="img-fluid"
                                          src="/assets/img/post/next.png"
                                          alt="Next post"
                                       />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     {/* ============= Sección del autor ============= */}
                     <div className="blog-author">
                        <div className="media align-items-center">
                           <img src="/assets/img/education/universidad-rusas-educacion.webp" alt="International education expert" />
                           <div className="media-body">
                              <a href="#"><h4>Dr. Irina Volkova</h4></a>
                              <p>Academic advisor with 10 years in international recruitment. Former admissions director at RUDN University.</p>
                           </div>
                        </div>
                     </div>

                     {/* ============= Sección de comentarios ============= */}
                     <div className="comments-area">
                        <h4>03 Comments</h4>
                        <div className="comment-list">
                           <div className="single-comment justify-content-between d-flex">
                              <div className="user justify-content-between d-flex">
                                 <div className="thumb">
                                    <img src="/assets/img/comment/comment_1.png" alt="User comment 1" />
                                 </div>
                                 <div className="desc">
                                    <p className="comment">
                                       Amazing atmosphere! The best way to enjoy summer in Moscow. 100% recommended
                                    </p>
                                    <div className="d-flex justify-content-between">
                                       <div className="d-flex align-items-center">
                                          <h5>
                                             <a href="#">Anna Petrova</a>
                                          </h5>
                                          <p className="date">May 15, 2024 at 3:12 pm </p>
                                       </div>
                                       <div className="reply-btn">
                                          <a href="#" className="btn-reply text-uppercase">
                                             reply
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className="comment-list">
                           <div className="single-comment justify-content-between d-flex">
                              <div className="user justify-content-between d-flex">
                                 <div className="thumb">
                                    <img src="/assets/img/comment/comment_2.png" alt="User comment 2" />
                                 </div>
                                 <div className="desc">
                                    <p className="comment">
                                       Is there parking near Gorky Park? I would like to attend by car
                                    </p>
                                    <div className="d-flex justify-content-between">
                                       <div className="d-flex align-items-center">
                                          <h5>
                                             <a href="#">Dmitry Sokolov</a>
                                          </h5>
                                          <p className="date">May 16, 2024 at 10:30 am </p>
                                       </div>
                                       <div className="reply-btn">
                                          <a href="#" className="btn-reply text-uppercase">
                                             reply
                                          </a>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        {/* Formulario de comentarios */}
                        <div className="comment-form">
                           <h4>Leave a comment</h4>
                           <form className="form-contact comment_form" action="#" id="commentForm">
                              <div className="row">
                                 <div className="col-12">
                                    <div className="form-group">
                                       <textarea
                                          className="form-control w-100"
                                          name="comment"
                                          id="comment"
                                          cols={30}
                                          rows={9}
                                          placeholder="Write your comment"
                                          defaultValue={""}
                                       />
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="name"
                                          id="name"
                                          type="text"
                                          placeholder="Name"
                                       />
                                    </div>
                                 </div>
                                 <div className="col-sm-6">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="email"
                                          id="email"
                                          type="email"
                                          placeholder="Email"
                                       />
                                    </div>
                                 </div>
                                 <div className="col-12">
                                    <div className="form-group">
                                       <input
                                          className="form-control"
                                          name="website"
                                          id="website"
                                          type="text"
                                          placeholder="Website"
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="form-group">
                                 <button
                                    type="submit"
                                    className="button button-contactForm btn_1 boxed-btn"
                                 >
                                    Post a comment
                                 </button>
                              </div>
                           </form>
                        </div>
                     </div>
                  </div>

                  {/* ==================== Sidebar ==================== */}

                  {/* ==================== Sidebar Completo ==================== */}
                  <div className="col-lg-4">
                     <div className="blog_right_sidebar">
                        <aside className="single_sidebar_widget search_widget">
                           <form action="#">
                              <div className="form-group">
                                 <div className="input-group mb-3">
                                    <input
                                       type="text"
                                       className="form-control"
                                       placeholder="Buscar"
                                       onFocus={(e) => e.target.placeholder = ''}
                                       onBlur={(e) => e.target.placeholder = 'Buscar'}
                                    />
                                    <div className="input-group-append">
                                       <button className="btns" type="button">
                                          <i className="ti-search" />
                                       </button>
                                    </div>
                                 </div>
                              </div>
                              <button
                                 className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                 type="submit"
                              >
                                 Buscar
                              </button>
                           </form>
                        </aside>

                        <aside className="single_sidebar_widget post_category_widget">
                           <h4 className="widget_title">Categorías</h4>
                           <ul className="list cat-list">
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Eventos</p>
                                    <p>(25)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Clases</p>
                                    <p>(12)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Consejos</p>
                                    <p>(8)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Vida Estudiantil</p>
                                    <p>(15)</p>
                                 </a>
                              </li>
                              <li>
                                 <a href="#" className="d-flex">
                                    <p>Becas</p>
                                    <p>(25)</p>
                                 </a>
                              </li>
                           </ul>
                        </aside>

                        {/* ============================== */}

                        <aside className="single_sidebar_widget popular_post_widget">
                           <h3 className="widget_title">Artículos Recientes</h3>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_1.png" alt="Post reciente 1" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Domina el Ruso en 6 Meses</h3>
                                 </a>
                                 <p>Mayo 10, 2024</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_2.png" alt="Post reciente 2" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Historia del Baile en Rusia</h3>
                                 </a>
                                 <p>Abril 28, 2024</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_3.png" alt="post" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Astronomy Or Astrology</h3>
                                 </a>
                                 <p>03 Days ago</p>
                              </div>
                           </div>
                           <div className="media post_item">
                              <img src="/assets/img/post/post_4.png" alt="post" />
                              <div className="media-body">
                                 <a href="#">
                                    <h3>Asteroids telescope</h3>
                                 </a>
                                 <p>01 Days ago</p>
                              </div>
                           </div>
                        </aside>

                        {/* ============================== */}                        

                        <aside className="single_sidebar_widget tag_cloud_widget">
                           <h4 className="widget_title">Etiquetas</h4>
                           <ul className="list">
                              <li><a href="#">Universidades</a></li>
                              <li><a href="#">Estudiar medicina</a></li>
                              <li><a href="#">Moscú</a></li>
                              <li><a href="#">Idioma Ruso</a></li>
                              <li><a href="#">Costo de vida</a></li>
                              <li><a href="#">Carreras</a></li>
                           </ul>
                        </aside>

                        {/* ============================== */}
                        
                        <aside className="single_sidebar_widget instagram_feeds">
                           <h4 className="widget_title">Instagram</h4>
                           <ul className="instagram_row flex-wrap">
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_5.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_6.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_7.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_8.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_9.png" alt=""/></a></li>
                           <li><a href="#"><img className="img-fluid" src="/assets/img/post/post_10.png" alt=""/></a></li>
                           </ul>
                        </aside>

                        <aside className="single_sidebar_widget newsletter_widget">
                           <h4 className="widget_title">Newsletter</h4>
                           <form action="#">
                              <div className="form-group">
                                 <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Ingresa tu email"
                                    required
                                 />
                              </div>
                              <button
                                 className="button rounded-0 primary-bg text-white w-100 btn_1 boxed-btn"
                                 type="submit"
                              >
                                 Suscribirse
                              </button>
                           </form>
                        </aside>
                     </div>
                  </div>

                  
               </div>
            </div>
         </section>






                  


         <Footer />
      </main >
   );
}

export default StudyInRussia;